import type { HubbleLike, TrackingProps, TrackingType } from './types.js';

const TIQ_HUBBLE_EVENT_NAME = 'tealium_iq_event';

export const forwardHubbleEventsIntoTealium = (
  hubble: HubbleLike,
  track: (type: TrackingType, props: TrackingProps) => void,
): void => {
  hubble.on('send', (events) => {
    for (const event of events) {
      if (event.name === TIQ_HUBBLE_EVENT_NAME) {
        continue;
      }
      track('link', {
        ...event,
        isHubbleEvent: true,
      });
    }
  });
};
